import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'
import { createRouterLayout } from 'vue-router-layout'
import Authentication from "@/helpers/Authentication";

const RouterLayout = createRouterLayout(layout => {
  return import('@/layouts/' + layout + '.vue')
})

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: RouterLayout,
      children: routes
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'page-404',
      component: () => import('@/components/404.vue')
    }
  ]
})

router.beforeEach((to,from,next) => {  
  if(to.meta.requiresAuth && !Authentication.checkAuthentication()){
    next({ 
      path: '/lk',
      query: {
        redirect: encodeURIComponent(to.fullPath)
      }
    })
  }else{
    const { title, description } = to.meta;
    const defaultTitle = 'СахалинТикет (SakhalinTicket)';
    const defaultDescription = 'Сервис бронирования билетов на мероприятия Сахалинской области';

    document.title = title || defaultTitle
    const descriptionElement = document.querySelector('head meta[name="description"]')
    descriptionElement.setAttribute('content', description || defaultDescription)
    next()
  }
  
})

export default router
